import { MeiliIndex } from './types';

export const SEARCH_RESULTS_MAX = 20;

export const getResultTitle = (type: MeiliIndex): string => {
  switch (type) {
    case MeiliIndex.tracks:
      return 'Tracks';
    case MeiliIndex.artists:
      return 'Artists';
    case MeiliIndex.playlists:
      return 'Playlists';
    default:
      return '';
  }
};

export const TRACK_PLACEHOLDER_ICON = 'fa-regular fa-music';
export const ARTIST_PLACEHOLDER_ICON = 'fa-regular fa-user-music';
export const PLAYLIST_PLACEHOLDER_ICON = 'fa-regular fa-list-music';
